<template>
<PageShell>
  <h1 class="site-h1">Contact Us</h1>
  <p class="site-lead">Thank you for visiting GBAppWhats.</p>
  <p>If you have questions, feedback, or suggestions about our website, we'd be happy to hear from you. We value reader feedback and use it to improve our content and keep information up to date.</p>

  <h2 class="site-h2">General Inquiries</h2>
  <p>If you need help navigating the website or have questions about our articles, feel free to contact us.</p>
  <div class="site-contact-box">
    <strong>Email:</strong>
    <a href="mailto:contact@gbappwhats.com">contact@gbappwhats.com</a>
  </div>

  <h2 class="site-h2">Report Incorrect Information</h2>
  <p>If you notice outdated information, broken links, or incorrect details, please let us know. We review all reports and update our content whenever necessary.</p>

  <h2 class="site-h2">Copyright Issues</h2>
  <p>If you believe any content on this website infringes your copyright, please contact us with the relevant information. We review copyright requests promptly and take appropriate action when required.</p>

  <h2 class="site-h2">Business Inquiries</h2>
  <p>For partnership opportunities, advertising questions, or other business-related inquiries, please email us using the address above.</p>

  <h2 class="site-h2">Response Time</h2>
  <p>Our team aims to respond to most inquiries within <strong>2–5 business days</strong>. Response times may vary depending on the volume of requests.</p>
  <p>Thank you for helping us improve GBAppWhats.</p>
</PageShell>
</template>

<script>
import PageShell from '@/components/PageShell.vue'

export default {
  name: 'Contact',
  components: { PageShell },
}
</script>

<style lang="scss" scoped>
.site-contact-box {
  background: var(--site-bg-alt);
  padding: 24px;
  border-radius: 12px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;

  a {
    color: var(--site-green);
    text-decoration: none;
    font-weight: bold;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
